import { render, staticRenderFns } from "./WATemplate.vue?vue&type=template&id=ff5a6ea6&scoped=true&"
import script from "./WATemplate.vue?vue&type=script&lang=js&"
export * from "./WATemplate.vue?vue&type=script&lang=js&"
import style0 from "./WATemplate.vue?vue&type=style&index=0&id=ff5a6ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5a6ea6",
  null
  
)

export default component.exports